<script>
    import {EventBus} from './eventBus';
    import IEUserAgent from './libs';

    export default {
        name: "EventBusMixin",
        computed: {
            pageLoaded() {
                return EventBus && EventBus.pageLoaded;
            },
            ieUserAgent() {
                return IEUserAgent.getVersion();
            },
            compatibilityMode() {
                return this.ieUserAgent.compatibilityMode && this.ieUserAgent.version < 11;
            }
        }
    }
</script>